/**
 * Add GTM specific features here.
 */

export function selectItem(){
    //GA4 - select item
    $(document).on("click",'.product-grid__item.col-xs-6.col-md-4', function(e) {
        var itemid = $(this).find('.product').data('itemid');
        var productLists = dataLayer.filter(o => o.productList != null);
        var product = productLists.find(s => s.productList.itemsList.find(o => o.id == itemid )).productList.itemsList.find(m => m.id == itemid );
        var lazyLoadPageSize = SitePreferences.LAZY_LOAD_PAGESIZE ? SitePreferences.LAZY_LOAD_PAGESIZE : 12;
        //GA4 events for select item
        var ecomObjectSelectItems = {
            event: "ecom_event",
            eventCategory: "ecommerce",
            eventAction: "select_item",
            ecommerce: {
                items: []
            }
        }
        var customProduct = {
            "item_id": product.item_id,
            "item_name":  product.item_name,
            "affiliation": product.affiliation ? product.affiliation : '',
            "coupon": product.coupon,
            "currency": product.currency,
            "discount": product.discount,
            "index": (+lazyLoadPageSize*(productLists.length-1)) + +product.position,
            "item_brand": product.item_brand,
            "item_category":product.item_category,
            "item_category2":product.item_category2,
            "item_category3":product.item_category3,
            "item_category4":product.item_category4,
            "item_category5":product.item_category5,
            "item_list_id": product.item_list_id,
            "item_list_name": product.item_list_name,
            "item_variant":product.item_variant,
            "location_id": product.location_id,
            "price": product.price,
            "quantity": product.quantity
        };
        ecomObjectSelectItems.ecommerce.items.push(customProduct);
        var productCategoryList = JSON.parse(sessionStorage.getItem('productCategoryList'))|| {};
        productCategoryList[product.item_id]= {"id" : product.item_list_id , "name" : product.item_list_name};
        sessionStorage.setItem('productCategoryList', JSON.stringify(productCategoryList));
        dataLayer.push(ecomObjectSelectItems);
    });
}

function handlePromotionClick(selector, eventAction) {
    $(document).on("click", selector, function(e) {
        var promotionList = dataLayer.filter(o => o.eventAction === "view_promotion");
        var promotionLabel = $(this).find("a").data("eventlabel");
        if(promotionLabel.length > 0){
            promotionLabel = promotionLabel.trim().replace(/"/g, '');
            var selectedPromotion = promotionList.filter(p => p.eventLabel === promotionLabel);  
        
            if (selectedPromotion.length > 0) {
                var ecomObject = selectedPromotion[0];
                ecomObject.eventAction = eventAction;
                dataLayer.push({ ecommerce: null }); 
                dataLayer.push(ecomObject);
            }
        }
    });
}

export function selectPromotion() {
    handlePromotionClick(".plp-listing-promo .product__promo", "select_promotion");
}

export function selectBannerPromotion() {
    handlePromotionClick(".plp-promo-banner .promo-banner__item", "select_promotion");
}

export function initCategoryNavigation() {
    // General function to handle category clicks
    function handleCategoryClick(selector, eventLabelPrefix) {
        $(document).on("click", selector, function(e) {
            var isVisualNav = $(this).children().eq(0).hasClass("cta-image");
            var eventCategory = $(this).attr('data-category');
            var category = $(this).attr('data-path');
            if(category.length > 0){
                category = category.split('|').pop();  
            }

            var user = dataLayer.find(o => o.user != null).user;
            var eventAction = isVisualNav ? `${eventLabelPrefix}_visual_cta_click` : `${eventLabelPrefix}_text_cta_click`;

            var CTAObject = {
                'event': 'custom_event',
                'eventCategory': eventCategory,
                'eventAction': eventAction,
                'eventLabel': category,
                'language': window.GlobalAttributes.LANGUAGE,
                'country': window.GlobalAttributes.COUNTRY,
                'loginMode': user.user_id !== '' ? "email" : "NA",
                'screenName': "PLP",
                'userType': user.user_id !== '' ? 'logged-in' : 'logged-out',
                'userId': user.user_id !== '' ? user.user_id : ''
            };

            dataLayer.push(CTAObject);
        });
    }

    // Initialize navigation for categories
    handleCategoryClick(".links-item .category-click", 'subcategory');
    handleCategoryClick(".cat-cta-item .category-click, .cat-cta-item--selected .category-click", 'subcategory');

}


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/helpers/gtm.utils.js